import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AddMfaDeviceComponent} from './add-mfa-device/add-mfa-device.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonTudComponentsModule} from '../common/common-tud-components.module';
import {TranslateModule} from '@ngx-translate/core';
import {EnabledDeviceComponent} from './enabled-device/enabled-device.component';
import {UserDeviceAdminComponent} from './user-device-admin/user-device-admin.component';
import {QRCodeComponent} from 'angularx-qrcode';
import {AuthenticateComponent} from './authenticate/authenticate.component';
import {AddableDeviceComponent} from './addable-device/addable-device.component';

@NgModule({
    imports: [
        //TUD Modules
        CommonTudComponentsModule,
        //Dependencies
        CommonModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        TranslateModule.forChild(),
        QRCodeComponent,
        AddMfaDeviceComponent,
        EnabledDeviceComponent,
        UserDeviceAdminComponent,
        AuthenticateComponent,
        AddableDeviceComponent
    ],
    exports: [
        AddMfaDeviceComponent,
        EnabledDeviceComponent,
        UserDeviceAdminComponent,
        AuthenticateComponent
    ]
})
export class MfaModule {}
